import { Icon, IconProps } from "@chakra-ui/react";

export const ChangeHistoryIcon = (props: IconProps) => (
  <Icon viewBox="0 0 20 21" fill="none" {...props}>
    <path
      d="M10.0002 18.8327C14.6025 18.8327 18.3335 15.1017 18.3335 10.4993C18.3335 5.89698 14.6025 2.16602 10.0001 2.16602C6.26876 2.16602 3.14538 4.61843 2.0835 7.99935H4.16683"
      stroke="#1819B4"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 7.16602V10.4993L11.6667 12.166"
      stroke="#1819B4"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.6665 10.5C1.6665 10.7811 1.67917 11.0591 1.70395 11.3333M7.49984 18.8333C7.21517 18.7396 6.93709 18.6304 6.6665 18.5065M2.67433 14.6667C2.51363 14.357 2.37027 14.036 2.24565 13.7052M4.02585 16.5887C4.28058 16.8632 4.55239 17.1201 4.83946 17.3577"
      stroke="#1819B4"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);
